"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Text_1 = __importDefault(require("../Text"));
const Switch_1 = __importDefault(require("../Switch"));
const Radio_1 = __importDefault(require("../Radio"));
const SelectableItem_style_1 = require("./SelectableItem.style");
const itemRow_1 = require("../../../images/itemRow");
function SelectableItem({ title, subtext, value, selected, control, onClick, onChange, arrow, outlined, leftIndicatorBarColor, }) {
    return (
    // <ComponentPadder padding="4px 0px">
    react_1.default.createElement(SelectableItem_style_1.SelectableItemContainer, { leftIndicatorBarColor: leftIndicatorBarColor, outlined: outlined, selected: selected, onClick: onClick || (() => onChange && onChange(!selected)) },
        react_1.default.createElement(SelectableItem_style_1.SelectableItemTitleContainer, null,
            react_1.default.createElement(Text_1.default, { size: 14 }, title),
            react_1.default.createElement(Text_1.default, { size: 10, opacity: "0.7" }, subtext)),
        value && (react_1.default.createElement(Text_1.default, { size: 16, bold: true, style: { paddingRight: '13px' } }, value)),
        control === 'switch' && react_1.default.createElement(Switch_1.default, { checked: selected, onChange: () => onChange && onChange(!selected) }),
        control === 'radio' && react_1.default.createElement(Radio_1.default, { checked: selected, onChange: () => onChange && onChange(!selected) }),
        arrow && react_1.default.createElement("img", { src: itemRow_1.rightArrow, style: { margin: 0 } }))
    // </ComponentPadder>
    );
}
exports.default = SelectableItem;
